import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { SharedService } from '../../shared.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  public projectForm!: FormGroup;

  public project:any;
  public loading = false;


  constructor(
    private sharedService: SharedService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.project = this.sharedService.getProject();
    this.projectForm = this.formBuilder.group({
      _id: [null],
      name: ['',Validators.required],
      type: ['', Validators.required],
      property_type: ['',Validators.required],
      base_price: ['',Validators.required],
      gst: ['',Validators.required],
      edc: ['', Validators.required],
      plc: this.formBuilder.array([this.addPlcGroup()]),
    })

    this.projectForm.patchValue(this.project);
    this.projectForm.setControl('plc', this.setExistingPlc(this.project.plc));
  }

  addPlcGroup(){
    return this.formBuilder.group({
      plc_name: [],
      price: []
    })
  }

  get plcArray(){
    return <FormArray>this.projectForm.get('plc')
  }

  addPlc(){
    this.plcArray.push(this.addPlcGroup())
  }

  removePlc(index:any){
    this.plcArray.removeAt(index);
  }

  setExistingPlc(plcs): FormArray{
    const formArray = new FormArray([]);
    plcs.forEach(plc => {
      formArray.push(this.formBuilder.group({
        plc_name: plc.plc_name,
        price: plc.price
      }))
    });
    return formArray
  }

  onSubmit(){
    if(this.projectForm.invalid){
      return;
    }else{
      this.loading = true;
      this.sharedService.updateProject(this.projectForm.value,this.projectForm.value._id).subscribe((data:any)=>{
        this.project = data.data;
        localStorage.setItem('project',  JSON.stringify(this.project));
        this.Toast.fire({
          title: 'Updated!',
          text: 'Updated successfully',
          icon: 'success'
        })
        this.loading = false;
      })
    }
  }

  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })



}
